import { Component, type ErrorInfo, type ReactNode } from 'react';

type ErrorBoundaryState = { failed: boolean };

export class ErrorBoundary extends Component<
  { children: ReactNode },
  ErrorBoundaryState
> {
  public state: ErrorBoundaryState = { failed: false };

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true };
  }

  public override componentDidCatch(_error: Error, _info: ErrorInfo): void {}

  public override render(): ReactNode {
    if (this.state.failed) {
      return (
        <main className="fatal-error">
          <div className="brand-mark" aria-hidden="true">
            AI
          </div>
          <h1>AI MessageBot kon niet worden weergegeven</h1>
          <p>Vernieuw de app. Er zijn geen berichten of sleutels naar logs gestuurd.</p>
          <button className="button primary" onClick={() => window.location.reload()}>
            App opnieuw laden
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
